if (!customElements.get('upsell-popup')) {
  customElements.define(
    'upsell-popup',
    class UpsellPopup extends HTMLElement {
      constructor() {
        super();
        this.closeEls = this.querySelectorAll('.upsell-modal__close');
        this.enabled = true;
        this.boundSubmit = false;
        // One-shot: after Continue, let the original form submit without reopening.
        this._bypassNextSubmit = false;

        this.closeEls.forEach((el) => {
          el.addEventListener('click', (e) => {
            e.preventDefault();
            this.hide();
          });
        });

        this.addEventListener('keyup', (e) => {
          if (e.code && e.code.toUpperCase() === 'ESCAPE') this.hide();
        });
        this.addEventListener('click', (e) => {
          if (e.target === this) this.hide();
        });
      }

      connectedCallback() {
        if (!this.moved) {
          this.moved = true;
          document.body.appendChild(this);
        }

        document.querySelectorAll('upsell-popup').forEach((el) => {
          if (el !== this) el.remove();
        });

        this.bindOriginalForm();

        if (window.theme && theme.AjaxProduct) {
          this.querySelectorAll('.product-single__form--upsell').forEach((form) => {
            if (form.dataset.ajaxBound === 'true') return;
            form.dataset.ajaxBound = 'true';
            new theme.AjaxProduct(form);
          });
        }
      }

      get originalForm() {
        return document.querySelector('.product-single__form-original');
      }

      formIsValid(form) {
        if (!form || typeof form.checkValidity !== 'function') return true;
        return form.checkValidity();
      }

      bindOriginalForm() {
        if (this.boundSubmit) return;
        this.boundSubmit = true;
        document.addEventListener('submit', this.onOriginalFormSubmit.bind(this), true);
        document.addEventListener('click', this.onPreorderClick.bind(this), true);
      }

      show(opener) {
        if (!this.enabled) return;
        this.openedBy = opener;
        document.body.classList.add('upsell-modal--open');
        this.setAttribute('open', '');
        if (window.theme && theme.a11y && theme.a11y.trapFocus) {
          theme.a11y.trapFocus({
            container: this,
            elementToFocus: this.querySelector('[role="dialog"]'),
            namespace: 'upsell-modal'
          });
        }
      }

      hide() {
        const form = this.originalForm;
        this._bypassNextSubmit = true;
        document.body.classList.remove('upsell-modal--open');
        this.removeAttribute('open');
        document.querySelectorAll('upsell-popup[open]').forEach((el) => {
          if (el !== this) el.removeAttribute('open');
        });
        if (window.theme && theme.a11y && theme.a11y.removeTrapFocus) {
          theme.a11y.removeTrapFocus({
            container: this,
            namespace: 'upsell-modal'
          });
        }
        if (form) {
          if (window.theme && theme.AjaxProduct && form.dataset.ajaxBound !== 'true') {
            form.dataset.ajaxBound = 'true';
            new theme.AjaxProduct(form);
          }
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else {
            form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
          }
        } else {
          this._bypassNextSubmit = false;
        }
      }

      onOriginalFormSubmit(event) {
        if (this._bypassNextSubmit) {
          this._bypassNextSubmit = false;
          return;
        }
        if (!this.enabled) return;
        const form = event.target;
        if (!form || !form.classList || !form.classList.contains('product-single__form-original')) return;

        // E1: required custom options must pass before upsell opens.
        if (!this.formIsValid(form)) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        this.show(event.submitter || null);
      }

      onPreorderClick(event) {
        if (this._bypassNextSubmit) return;
        if (!this.enabled) return;
        const btn = event.target && event.target.closest('button[type="submit"], [data-add-to-cart]');
        if (!btn) return;
        const form = btn.closest('.product-single__form-original.starfire-preorder-form');
        if (!form) return;
        if (!btn.classList.contains('preorder') && form.querySelector('[data-is-preorder]')?.value !== 'true') return;

        if (!this.formIsValid(form)) {
          event.preventDefault();
          event.stopPropagation();
          if (typeof form.reportValidity === 'function') form.reportValidity();
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        this.show(btn);
      }
    }
  );
}

function starfireUpsellModalUrl(handle) {
  const home = (window.theme && theme.routes && theme.routes.home) || '/';
  let url = home + '/products/' + handle + '?view=upsell';
  return url.replace('//', '/');
}

function findStarfireUpsellHolder(handle, btn) {
  // Prefer the modal tied to this button (PDP vs -popup), even after it was moved to body.
  if (btn) {
    const btnModal =
      btn.closest('.modal-upsell') ||
      (function() {
        const openClass = Array.prototype.find.call(btn.classList || [], function(c) {
          return c.indexOf('js-modal-open-quick-modal-') === 0;
        });
        if (!openClass) return null;
        const productId = openClass.replace('js-modal-open-quick-modal-', '');
        return (
          document.getElementById('QuickShopModal-' + productId) ||
          document.getElementById('QuickShopModal-' + productId.replace(/-popup$/, '') + '-popup')
        );
      })();
    if (btnModal) {
      const inModal =
        btnModal.querySelector('[data-upsell-holder="' + handle + '"]') ||
        btnModal.querySelector('[id="QuickShopHolder-' + handle + '"]') ||
        btnModal.querySelector('[id="QuickShopHolder-' + handle + '-popup"]');
      if (inModal) return inModal;
    }
  }

  const scope =
    (btn && (btn.closest('upsell-popup') || btn.closest('.product-block--upsells') || btn.closest('.modal-upsell'))) ||
    null;

  if (scope) {
    const scoped =
      scope.querySelector('[data-upsell-holder="' + handle + '"]') ||
      scope.querySelector('[id="QuickShopHolder-' + handle + '"]') ||
      scope.querySelector('[id="QuickShopHolder-' + handle + '-popup"]');
    if (scoped) return scoped;
  }

  // Modal may already have been moved to <body> — still prefer the matching suffix.
  const wantPopup = Boolean(btn && btn.className && btn.className.indexOf('-popup') !== -1);
  const holders = document.querySelectorAll(
    '[data-upsell-holder="' + handle + '"], [id="QuickShopHolder-' + handle + '"], [id="QuickShopHolder-' + handle + '-popup"]'
  );
  for (let i = 0; i < holders.length; i++) {
    const holder = holders[i];
    const isPopup =
      (holder.id && holder.id.indexOf('-popup') !== -1) ||
      (holder.closest('.modal-upsell') && holder.closest('.modal-upsell').id.indexOf('-popup') !== -1);
    if (wantPopup !== isPopup) continue;
    if (holder.closest('.modal-upsell') || holder.hasAttribute('data-upsell-holder')) {
      return holder;
    }
  }
  for (let j = 0; j < holders.length; j++) {
    if (holders[j].closest('.modal-upsell') || holders[j].hasAttribute('data-upsell-holder')) {
      return holders[j];
    }
  }
  return document.getElementById('QuickShopHolder-' + handle);
}

function ensureUpsellModalWired(productId, modalEl) {
  if (!window.theme || !theme.Modals) return null;
  const baseId = String(productId || '').replace(/-popup$/, '');
  const modal =
    modalEl ||
    document.getElementById('QuickShopModal-' + productId) ||
    document.getElementById('QuickShopModal-' + baseId) ||
    document.getElementById('QuickShopModal-' + baseId + '-popup');
  if (!modal || !modal.id) return null;
  if (modal.dataset.starfireModalWired === 'true') return modal;

  const isPopup = modal.id.indexOf('-popup') !== -1;
  const modalName = 'quick-modal-' + baseId + (isPopup ? '-popup' : '');
  try {
    new theme.Modals(modal.id, modalName);
    modal.dataset.starfireModalWired = 'true';
  } catch (err) {}
  return modal;
}

function openStarfireUpsellModal(productId, handle, btn) {
  const baseId = String(productId || '').replace(/-popup$/, '');
  const wantPopup = Boolean(btn && btn.className && String(btn.className).indexOf('-popup') !== -1);
  const modal =
    document.getElementById('QuickShopModal-' + baseId + (wantPopup ? '-popup' : '')) ||
    document.getElementById('QuickShopModal-' + baseId) ||
    document.getElementById('QuickShopModal-' + baseId + '-popup');
  if (!modal) return false;

  ensureUpsellModalWired(baseId + (wantPopup ? '-popup' : ''), modal);
  if (handle) preloadStarfireUpsellModal(handle, baseId, btn);

  if (!modal.classList.contains('modal--is-active')) {
    modal.classList.add('modal--is-active');
    document.documentElement.classList.add('modal-open');
    try {
      document.dispatchEvent(new CustomEvent('modalOpen.' + modal.id));
    } catch (err) {}
  }
  return true;
}

function bindUpsellQuickShopOpenFallback() {
  if (document._starfireUpsellOpenFallback) return;
  document._starfireUpsellOpenFallback = true;
  document.addEventListener('click', function(evt) {
    const btn = evt.target && evt.target.closest && evt.target.closest(
      '.product-block--upsells .quick-product__btn, upsell-popup .quick-product__btn'
    );
    if (!btn) return;

    const openClass = Array.prototype.find.call(btn.classList || [], function(c) {
      return c.indexOf('js-modal-open-quick-modal-') === 0;
    });
    if (!openClass) return;

    const productId = openClass.replace('js-modal-open-quick-modal-', '');
    const baseId = productId.replace(/-popup$/, '');
    const card = btn.closest('[data-product-handle], [data-product-id]');
    const handle =
      (card && (card.getAttribute('data-product-handle') || (card.dataset && card.dataset.productHandle))) ||
      '';

    const modal =
      document.getElementById('QuickShopModal-' + productId) ||
      document.getElementById('QuickShopModal-' + baseId) ||
      document.getElementById('QuickShopModal-' + baseId + '-popup');

    // Impulse Modals already active — still ensure content preload.
    if (modal && modal.classList.contains('modal--is-active')) {
      if (handle) preloadStarfireUpsellModal(handle, baseId, btn);
      return;
    }

    // If Modals never bound (common after id/inject churn), open ourselves.
    if (!modal || modal.dataset.starfireModalWired !== 'true') {
      evt.preventDefault();
      evt.stopPropagation();
      openStarfireUpsellModal(productId, handle, btn);
    } else if (handle) {
      preloadStarfireUpsellModal(handle, baseId, btn);
    }
  });
}

function escapeAttrSelector(value) {
  if (window.CSS && typeof CSS.escape === 'function') return CSS.escape(value);
  return String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
}

function isStarfireUpsellHolder(holder) {
  if (!holder) return false;
  return Boolean(
    holder.closest('.modal-upsell') ||
      holder.closest('.product-block--upsells') ||
      holder.closest('upsell-popup') ||
      holder.hasAttribute('data-upsell-holder')
  );
}

// ?view=upsell injects a full form with data-modal="true". Product defers formSetup
// until modalOpen + [data-blocks-holder] fetch — neither matches this path, so ATC
// would native-POST to /cart. Wire AjaxProduct (and variant UI) immediately instead.

function normalizeUpsellOptionValue(value) {
  return String(value == null ? '' : value)
    .replace(/\u00a0/g, ' ')
    .replace(/[\u201C\u201D\u201E\u201F]/g, '"')
    .replace(/[\u2018\u2019]/g, "'")
    .trim();
}

function isUpsellModalForm(form) {
  return Boolean(
    form &&
      (form.closest('.modal-upsell') ||
        form.closest('[data-upsell-holder]') ||
        form.classList.contains('product-single__form--upsell'))
  );
}

function getUpsellProductContainer(form) {
  if (!form) return null;
  // Prefer the upsell card / Quick Shop modal — never climb to the parent PDP
  // section first (on-page autoclave cards live inside it and would resolve the
  // main product's variant id).
  return (
    form.closest('.modal-upsell') ||
    form.closest('[data-upsell-holder]') ||
    form.closest('.grid-product') ||
    form.closest('[data-section-type="product"]')
  );
}

function readUpsellSelectedOptions(container, form) {
  const selected = {};
  // Always read from the modal/card root — never the parent PDP section
  // (on-page lean cards live inside it and would inherit main options).
  const root =
    (form &&
      (form.closest('.modal-upsell') ||
        form.closest('[data-upsell-holder]') ||
        form.closest('.grid-product'))) ||
    container;
  if (!root) return selected;

  root.querySelectorAll('select[data-variant-input]').forEach(function(sel) {
    const idx = sel.getAttribute('data-index') || (sel.dataset && sel.dataset.index);
    if (!idx) return;
    selected[idx] = sel.value;
  });

  root.querySelectorAll('input[data-variant-input]').forEach(function(input) {
    if ((input.type === 'radio' || input.type === 'checkbox') && !input.checked) return;
    const idx = input.getAttribute('data-index') || (input.dataset && input.dataset.index);
    if (!idx) return;
    selected[idx] = input.value;
  });
  return selected;
}

function optionsKeyFromSelected(selected) {
  try {
    return JSON.stringify(selected || {});
  } catch (err) {
    return '';
  }
}

function matchVariantFromList(variants, selected) {
  if (!Array.isArray(variants) || !variants.length) return null;
  const keys = Object.keys(selected || {});
  if (!keys.length) return null;

  const fullMatch = function(needsAvailable) {
    return variants.find(function(variant) {
      if (needsAvailable && !variant.available) return false;
      return keys.every(function(key) {
        return normalizeUpsellOptionValue(variant[key]) === normalizeUpsellOptionValue(selected[key]);
      });
    });
  };
  return fullMatch(true) || fullMatch(false) || null;
}

function parseLocalUpsellVariants(container) {
  if (!container) return [];
  const jsonEl = container.querySelector('[data-variant-json]');
  if (!jsonEl) return [];
  try {
    const parsed = JSON.parse(jsonEl.textContent);
    return Array.isArray(parsed) ? parsed : [];
  } catch (err) {
    return [];
  }
}

var upsellProductJsCache = {};

function fetchUpsellProductVariants(handle) {
  if (!handle) return Promise.resolve([]);
  if (upsellProductJsCache[handle]) return upsellProductJsCache[handle];

  const home = (window.theme && theme.routes && theme.routes.home) || '/';
  const prefix = home === '/' ? '' : String(home).replace(/\/$/, '');
  const url = prefix + '/products/' + handle + '.js';

  upsellProductJsCache[handle] = fetch(url, {
    credentials: 'same-origin',
    headers: { 'X-Requested-With': 'XMLHttpRequest' }
  })
    .then(function(response) {
      return response.json();
    })
    .then(function(product) {
      return (product && product.variants) || [];
    })
    .catch(function() {
      delete upsellProductJsCache[handle];
      return [];
    });

  return upsellProductJsCache[handle];
}

function getUpsellHandle(container, form) {
  return (
    (container && container.getAttribute('data-product-handle')) ||
    (form && form.closest('[data-product-handle]') &&
      form.closest('[data-product-handle]').getAttribute('data-product-handle')) ||
    (container &&
      container.querySelector('[data-product-handle]') &&
      container.querySelector('[data-product-handle]').getAttribute('data-product-handle')) ||
    ''
  );
}

function formHasUpsellOptionPickers(container, form) {
  const root =
    (form &&
      (form.closest('.modal-upsell') ||
        form.closest('[data-upsell-holder]') ||
        form.closest('.grid-product'))) ||
    container ||
    form;
  if (!root || !root.querySelectorAll) return false;
  // Lean single-variant cards have no option UI of their own.
  if (form && form.classList.contains('product-single__form--upsell') && form.closest('.grid-product')) {
    return Boolean(
      form.closest('.grid-product').querySelector('select[data-variant-input], input[data-variant-input]')
    );
  }
  return Boolean(root.querySelector('select[data-variant-input], input[data-variant-input]'));
}

function readUpsellMasterVariantId(form) {
  if (!form) return null;
  const el =
    form.querySelector('input[name="id"]:not([disabled])') ||
    form.querySelector('select[name="id"]') ||
    form.querySelector('[data-product-select]');
  if (!el || el.value === '' || el.value == null) return null;
  return Number(el.value) || el.value;
}

function resolveUpsellVariantFromDom(container, form) {
  const selected = readUpsellSelectedOptions(container, form);
  if (!Object.keys(selected).length && !formHasUpsellOptionPickers(container, form)) {
    const id = readUpsellMasterVariantId(form);
    return id ? { id: id, available: true } : null;
  }
  return matchVariantFromList(parseLocalUpsellVariants(container), selected);
}

function resolveUpsellVariantForForm(form) {
  const container = getUpsellProductContainer(form);
  const selected = readUpsellSelectedOptions(container, form);
  const key = optionsKeyFromSelected(selected);

  // No option pickers (single/default-variant upsell card): use the form's id.
  if (!Object.keys(selected).length) {
    if (formHasUpsellOptionPickers(container, form)) {
      return Promise.resolve(null);
    }
    const id = readUpsellMasterVariantId(form);
    if (!id) return Promise.resolve(null);
    form.dataset.upsellResolvedId = String(id);
    form.dataset.upsellOptionsKey = key;
    return Promise.resolve({ id: id, available: true });
  }

  const local = matchVariantFromList(parseLocalUpsellVariants(container), selected);
  if (local && local.id) {
    form.dataset.upsellResolvedId = String(local.id);
    form.dataset.upsellOptionsKey = key;
    return Promise.resolve(local);
  }

  const variantsUi = container && (container._starfireVariants || (container._starfireProduct && container._starfireProduct.variants));
  if (variantsUi && typeof variantsUi._getVariantFromOptions === 'function') {
    try {
      const live = variantsUi._getVariantFromOptions();
      if (live && live.id) {
        const matches = Object.keys(selected).every(function(k) {
          return normalizeUpsellOptionValue(live[k]) === normalizeUpsellOptionValue(selected[k]);
        });
        if (matches) {
          form.dataset.upsellResolvedId = String(live.id);
          form.dataset.upsellOptionsKey = key;
          return Promise.resolve(live);
        }
      }
    } catch (err) {}
  }

  const handle = getUpsellHandle(container, form);
  return fetchUpsellProductVariants(handle).then(function(variants) {
    const matched = matchVariantFromList(variants, selected);
    if (matched && matched.id) {
      form.dataset.upsellResolvedId = String(matched.id);
      form.dataset.upsellOptionsKey = key;
      return matched;
    }
    if (form.dataset.upsellResolvedId && form.dataset.upsellOptionsKey === key) {
      return { id: Number(form.dataset.upsellResolvedId) || form.dataset.upsellResolvedId };
    }
    return null;
  });
}

function variantMatchesSelectedOptions(variant, selected, container, form) {
  if (!variant || !variant.id || !selected) return false;
  const keys = Object.keys(selected);
  // Single-variant upsell cards have no option UI — trust the resolved id.
  if (!keys.length) return !formHasUpsellOptionPickers(container, form);
  return keys.every(function(key) {
    return normalizeUpsellOptionValue(variant[key]) === normalizeUpsellOptionValue(selected[key]);
  });
}

function setUpsellCartButtonState(form, variant) {
  if (!form) return;
  const container = getUpsellProductContainer(form);
  const button =
    form.querySelector('[data-add-to-cart]') ||
    (container && container.querySelector('[data-add-to-cart]'));
  const buttonText =
    (button && button.querySelector('[data-add-to-cart-text]')) ||
    form.querySelector('[data-add-to-cart-text]') ||
    (container && container.querySelector('[data-add-to-cart-text]'));
  const unavailableText =
    (window.theme && theme.strings && theme.strings.unavailable) || 'Unavailable';
  const soldOutText =
    (window.theme && theme.strings && theme.strings.soldOut) || 'Sold out';
  const defaultText =
    (buttonText && buttonText.dataset && buttonText.dataset.defaultText) ||
    (window.theme && theme.strings && theme.strings.addToCart) ||
    'Add to cart';

  if (!button) return;

  if (!variant || !variant.id) {
    button.disabled = true;
    button.setAttribute('disabled', 'disabled');
    button.classList.add('disabled');
    button.classList.remove('preorder');
    button.setAttribute('aria-disabled', 'true');
    if (buttonText) {
      buttonText.textContent = unavailableText;
      buttonText.dataset.starfireUpsellLabel = unavailableText;
    }
    form.dataset.upsellUnavailable = 'true';
    return;
  }

  if (variant.available === false) {
    button.disabled = true;
    button.setAttribute('disabled', 'disabled');
    button.classList.add('disabled');
    button.classList.remove('preorder');
    button.setAttribute('aria-disabled', 'true');
    if (buttonText) {
      let showAsUnavailable = false;
      const dataEl = container && container.querySelector('[data-show-sold-out-as-unavailable]');
      if (dataEl) {
        try {
          const map = JSON.parse(dataEl.textContent);
          showAsUnavailable = Boolean(map && (map[variant.id] || map[String(variant.id)]));
        } catch (err) {}
      }
      const label = showAsUnavailable ? unavailableText : soldOutText;
      buttonText.textContent = label;
      buttonText.dataset.starfireUpsellLabel = label;
    }
    form.dataset.upsellUnavailable = 'true';
    return;
  }

  button.disabled = false;
  button.removeAttribute('disabled');
  button.classList.remove('disabled');
  button.removeAttribute('aria-disabled');
  delete form.dataset.upsellUnavailable;
  if (buttonText) {
    buttonText.textContent = defaultText;
    buttonText.dataset.starfireUpsellLabel = defaultText;
  }
}

function clearUpsellVariantFromForm(form) {
  if (!form) return;
  const container = getUpsellProductContainer(form);

  delete form.dataset.upsellResolvedId;
  delete form.dataset.upsellOptionsKey;
  form.dataset.upsellUnavailable = 'true';

  // Strip every name=id so a stale master <select> cannot POST the previous variant.
  form.querySelectorAll('[name="id"]').forEach(function(el) {
    el.removeAttribute('name');
    if (el.hasAttribute('data-upsell-variant-id')) {
      el.value = '';
      el.disabled = true;
    }
  });

  const master = form.querySelector('[data-product-select], select.product-single__variants');
  if (master && master.tagName === 'SELECT') {
    master.removeAttribute('name');
    master.selectedIndex = -1;
  }

  if (container && container._starfireVariants) {
    container._starfireVariants.currentVariant = null;
  }

  setUpsellCartButtonState(form, null);

  // Scope to this modal only — do not broadcast variant:change (that would
  // flip the main PDP ATC to Unavailable).
  try {
    if (container) {
      const selected = readUpsellSelectedOptions(container, form);
      const currentlySelectedValues = Object.keys(selected).map(function(index) {
        return { index: index, value: selected[index] };
      });
      container.dispatchEvent(
        new CustomEvent('variantChange', {
          detail: {
            variant: null,
            currentlySelectedValues: currentlySelectedValues,
            value: null,
            index: currentlySelectedValues[0] && currentlySelectedValues[0].index
          }
        })
      );
    }
  } catch (err) {}
}

function applyUpsellVariantToForm(form, variant) {
  if (!form || !variant || !variant.id) return null;
  const id = String(variant.id);
  const container = getUpsellProductContainer(form);
  const selected = readUpsellSelectedOptions(container, form);
  // Never stamp an id that does not match the visible dropdowns.
  if (Object.keys(selected).length && !variantMatchesSelectedOptions(variant, selected, container, form)) {
    clearUpsellVariantFromForm(form);
    return null;
  }

  const master = form.querySelector('[data-product-select], select.product-single__variants, select[name="id"]');
  if (master && master.tagName === 'SELECT') {
    let opt = null;
    Array.from(master.options).forEach(function(option) {
      if (String(option.value) === id) opt = option;
    });
    if (!opt) {
      opt = document.createElement('option');
      opt.value = id;
      opt.textContent = variant.title || variant.name || id;
      master.appendChild(opt);
    }
    opt.disabled = false;
    master.value = id;
    master.removeAttribute('name');
    master.setAttribute('data-product-select', '');
  }

  let hidden = form.querySelector('input[data-upsell-variant-id]');
  if (!hidden) {
    hidden = document.createElement('input');
    hidden.type = 'hidden';
    hidden.setAttribute('data-upsell-variant-id', 'true');
    form.appendChild(hidden);
  }
  form.querySelectorAll('[name="id"]').forEach(function(el) {
    if (el === hidden) return;
    el.removeAttribute('name');
  });
  hidden.name = 'id';
  hidden.value = id;
  hidden.disabled = false;

  form.dataset.upsellResolvedId = id;
  form.dataset.upsellOptionsKey = optionsKeyFromSelected(selected);
  delete form.dataset.upsellUnavailable;

  if (container && container._starfireVariants) {
    container._starfireVariants.currentVariant = variant;
  }
  setUpsellCartButtonState(form, variant);
  return variant;
}

function forceUpsellVariantOnForm(form) {
  if (!form) return null;
  const container = getUpsellProductContainer(form);
  const variant = resolveUpsellVariantFromDom(container, form);
  if (!variant || !variant.id) return null;
  return applyUpsellVariantToForm(form, variant);
}

window.starfireForceUpsellVariantOnForm = forceUpsellVariantOnForm;

function buildUpsellCartFormData(form, variant) {
  const container = getUpsellProductContainer(form);
  const selected = readUpsellSelectedOptions(container, form);

  if (!variant || !variant.id || !variantMatchesSelectedOptions(variant, selected, container, form)) {
    clearUpsellVariantFromForm(form);
    return { formData: null, variant: null };
  }

  applyUpsellVariantToForm(form, variant);

  const formData = new FormData(form);
  const scope =
    form.closest('.modal-upsell') ||
    form.closest('[data-section-type="product"]') ||
    form;

  if (form.id) {
    const escaped = escapeAttrSelector(form.id);
    scope.querySelectorAll('[form="' + escaped + '"]').forEach(function(el) {
      if (!el.name || el.disabled || el.name === 'id') return;
      if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
      if (el.value === '' || el.value == null) {
        formData.delete(el.name);
        return;
      }
      formData.set(el.name, el.value);
    });
  }

  formData.set('id', String(variant.id));

  ['preorder', 'variant_inv', 'variant_inv_remaining', 'variant_cart_qty', 'variant_cart_preorders'].forEach(function(key) {
    formData.delete(key);
  });

  return { formData: formData, variant: variant };
}

function openUpsellCartDrawer() {
  // Never navigate to /cart for QuickShop — always refresh + open drawer when present.
  if (!document.getElementById('CartDrawer')) return;
  setTimeout(function() {
    document.dispatchEvent(new CustomEvent('cart:open'));
  }, 50);
}

function isUpsellPopupQuickShop(form, addBtn) {
  const modal =
    (form && form.closest('.modal-upsell')) ||
    (addBtn && addBtn.closest('.modal-upsell'));
  if (!modal) return false;
  // Live: Quick Shop from the upsell popup closes and returns to the popup —
  // do not open the cart drawer (that stacks windows and skips Continue).
  return Boolean(
    document.querySelector('upsell-popup[open]') ||
      modal.classList.contains('modal-upsell')
  );
}

function notifyUpsellAdded(form, product, addBtn) {
  const detail = { product: product, addToCartBtn: addBtn };
  form.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: detail, bubbles: true }));
  document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: detail }));
  // On-page "Add this" can open the drawer. Popup Quick Shop must not —
  // Continue on the upsell popup adds the original PDP item afterward.
  if (!isUpsellPopupQuickShop(form, addBtn)) {
    openUpsellCartDrawer();
  }
}

function submitStarfireUpsellForm(form, evt) {
  if (evt) {
    evt.preventDefault();
    evt.stopPropagation();
    evt.stopImmediatePropagation();
  }
  if (!form || !window.theme || !theme.routes || !theme.routes.cartAdd) return false;

  // Hard block: invalid / unmatched option combos must never hit /cart/add.
  if (form.dataset.upsellUnavailable === 'true') {
    clearUpsellVariantFromForm(form);
    return false;
  }

  const addBtn = form.querySelector('[data-add-to-cart], button[type="submit"], [type="submit"]');
  if (addBtn && (addBtn.disabled || addBtn.classList.contains('disabled'))) {
    clearUpsellVariantFromForm(form);
    return false;
  }
  if (addBtn && addBtn.classList.contains('btn--loading')) return false;
  if (addBtn) addBtn.classList.add('btn--loading');

  resolveUpsellVariantForForm(form)
    .then(function(variant) {
      const container = getUpsellProductContainer(form);
      const selected = readUpsellSelectedOptions(container, form);
      if (!variant || !variant.id || !variantMatchesSelectedOptions(variant, selected, container, form)) {
        clearUpsellVariantFromForm(form);
        if (addBtn) addBtn.classList.remove('btn--loading');
        return null;
      }
      const built = buildUpsellCartFormData(form, variant);
      if (!built.formData || !built.formData.get('id')) {
        clearUpsellVariantFromForm(form);
        if (addBtn) addBtn.classList.remove('btn--loading');
        return null;
      }
      const formData = built.formData;
      if (!formData.get('quantity')) formData.set('quantity', '1');
      formData.set('id', String(variant.id));

      return fetch(theme.routes.cartAdd, {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }
      }).then(function(response) {
        return response.json();
      });
    })
    .then(function(data) {
      if (!data) return;
      if (addBtn) addBtn.classList.remove('btn--loading');
      if (data.status === 422) {
        const errorDiv = document.createElement('div');
        errorDiv.className = 'errors text-center';
        errorDiv.textContent = data.description || data.message || 'Unable to add to cart';
        const existing = form.querySelector('.errors');
        if (existing) existing.remove();
        form.appendChild(errorDiv);
        return;
      }
      notifyUpsellAdded(form, data, addBtn);
    })
    .catch(function() {
      if (addBtn) addBtn.classList.remove('btn--loading');
    });

  return false;
}

function bindUpsellModalAjaxAdd(form) {
  if (!form || form._starfireUpsellAjaxAdd) return;
  form._starfireUpsellAjaxAdd = true;
  form.addEventListener(
    'submit',
    function(evt) {
      submitStarfireUpsellForm(form, evt);
    },
    true
  );
}

function bindDocumentUpsellAjaxCapture() {
  if (document._starfireUpsellDocCapture) return;
  document._starfireUpsellDocCapture = true;
  // Capture before Impulse / native POST can navigate to /cart.
  document.addEventListener(
    'submit',
    function(evt) {
      const form = evt.target;
      if (!isUpsellModalForm(form)) return;
      submitStarfireUpsellForm(form, evt);
    },
    true
  );
}

window.submitStarfireUpsellForm = submitStarfireUpsellForm;

function syncUpsellMasterSelect(container) {
  if (!container) return;
  const form =
    container.querySelector('.product-single__form--upsell') ||
    container.querySelector('.product-single__form');
  if (!form) return;

  // Paint ATC immediately from local JSON so invalid combos flip to Unavailable
  // on option change — do not wait for /products/{handle}.js or click/submit.
  const localVariant = resolveUpsellVariantFromDom(container, form);
  if (localVariant && localVariant.id) {
    applyUpsellVariantToForm(form, localVariant);
  } else {
    clearUpsellVariantFromForm(form);
  }

  // Exact option combo only — never keep a previous variant id when the
  // current Gauge/Length/Disk selection does not exist (live → Unavailable).
  // Refine with full product.js when Liquid JSON is truncated (~250).
  const syncId = (form._upsellSyncId || 0) + 1;
  form._upsellSyncId = syncId;
  resolveUpsellVariantForForm(form).then(function(variant) {
    if (form._upsellSyncId !== syncId) return;
    if (variant && variant.id) applyUpsellVariantToForm(form, variant);
    else clearUpsellVariantFromForm(form);
  });
}

function isUpsellOptionControl(el) {
  if (!el || !el.matches) return false;
  return el.matches(
    'select[data-variant-input], input[data-variant-input], select.single-option-selector, .single-option-selector'
  );
}

function wireUpsellOptionSync(container) {
  if (!container) return;
  // Re-bind when markup was re-injected into the same holder.
  if (container._starfireUpsellOptionSync) return;
  container._starfireUpsellOptionSync = true;

  container.addEventListener('change', function(evt) {
    const t = evt.target;
    if (!isUpsellOptionControl(t)) return;
    // After Impulse/starfire _onSelectChange so our exact-match ATC wins.
    setTimeout(function() {
      syncUpsellMasterSelect(container);
    }, 0);
    // VariantAvailability / preorder label locks can paint one tick later.
    setTimeout(function() {
      syncUpsellMasterSelect(container);
    }, 50);
  });
}

function bindDocumentUpsellOptionSync() {
  if (document._starfireUpsellOptionDocSync) return;
  document._starfireUpsellOptionDocSync = true;

  document.addEventListener(
    'change',
    function(evt) {
      const target = evt.target;
      if (!isUpsellOptionControl(target)) return;
      const modal = target.closest('.modal-upsell');
      const holder = target.closest('[data-upsell-holder]');
      if (!modal && !holder) return;
      const root = modal || holder;
      const container =
        target.closest('[data-section-type="product"]') ||
        root.querySelector('[data-section-type="product"]') ||
        root;
      setTimeout(function() {
        syncUpsellMasterSelect(container);
      }, 0);
      setTimeout(function() {
        syncUpsellMasterSelect(container);
      }, 50);
    },
    true
  );
}

function upsellIdSuffixForHolder(holder) {
  // Live uses -modal on form / select / form=. Keep -popup for the Continue-shopping
  // popup so it never collides with on-page QuickShop of the same SKU.
  const modal = holder && holder.closest('.modal-upsell');
  if ((modal && modal.id && modal.id.indexOf('-popup') !== -1) ||
      (holder && holder.id && holder.id.indexOf('-popup') !== -1)) {
    return '-popup';
  }
  return '-modal';
}

/**
 * Popup and PDP QuickShop both inject the same ?view=upsell markup, so form /
 * section / option IDs collide. Uniquify within each holder so form= associations
 * and theme.sections Product instances stay scoped to that modal.
 *
 * Live pattern: form id, select ids, and every form= attribute share the same suffix.
 * Liquid may already stamp -modal; skip ids that already end with the suffix.
 */
function uniquifyInjectedUpsellIds(holder) {
  if (!holder) return;
  const suffix = upsellIdSuffixForHolder(holder);

  // Re-run if flag was left set from a previous inject but fresh markup lacks suffix.
  if (holder.dataset.upsellIdsUnique === 'true') {
    const stale = Array.prototype.some.call(holder.querySelectorAll('[id]'), function(el) {
      return el.id && el.id.slice(-suffix.length) !== suffix;
    });
    if (!stale) {
      // Still repair orphaned form= pointing at an unsuffixed AddToCartForm.
      holder.querySelectorAll('.product-single__form[id]').forEach(function(form) {
        syncUpsellFormAssociations(holder, form);
      });
      return;
    }
  }

  holder.querySelectorAll('[id]').forEach(function(el) {
    const oldId = el.id;
    if (!oldId || oldId.slice(-suffix.length) === suffix) return;
    const newId = oldId + suffix;
    el.id = newId;
    const escaped = escapeAttrSelector(oldId);
    holder.querySelectorAll('[for="' + escaped + '"]').forEach(function(label) {
      label.setAttribute('for', newId);
    });
    holder.querySelectorAll('[form="' + escaped + '"]').forEach(function(control) {
      control.setAttribute('form', newId);
    });
  });

  // Explicit live match: form id + every form= must stay in sync (selects live outside the form).
  holder.querySelectorAll('.product-single__form[id], form.product-single__form--upsell[id]').forEach(function(form) {
    let formId = form.id;
    if (formId.slice(-suffix.length) !== suffix) {
      formId = formId + suffix;
      form.id = formId;
    }
    syncUpsellFormAssociations(holder, form);
  });

  holder.querySelectorAll('[data-section-id]').forEach(function(el) {
    const sid = el.getAttribute('data-section-id');
    if (sid && sid.slice(-suffix.length) !== suffix) {
      el.setAttribute('data-section-id', sid + suffix);
    }
  });

  holder.dataset.upsellIdsUnique = 'true';
}

function syncUpsellFormAssociations(holder, form) {
  if (!holder || !form || !form.id) return;
  const formId = form.id;
  const baseId = formId.replace(/-(modal|popup|qs)$/, '');
  // Point every control that referenced the unsuffixed (or any known) id at this form.
  [baseId, formId.replace(/-popup$/, ''), formId.replace(/-modal$/, ''), formId.replace(/-qs$/, '')].forEach(function(candidate) {
    if (!candidate || candidate === formId) return;
    const escaped = escapeAttrSelector(candidate);
    holder.querySelectorAll('[form="' + escaped + '"]').forEach(function(control) {
      control.setAttribute('form', formId);
    });
  });
  // Variant selects in this holder with no form= (or wrong form=) — bind to this form.
  holder.querySelectorAll('select[data-variant-input], input[data-variant-input]').forEach(function(control) {
    const current = control.getAttribute('form');
    if (!current || current === baseId || current.slice(0, baseId.length) === baseId) {
      control.setAttribute('form', formId);
    }
  });
}

function initInjectedUpsellProduct(holder, modalEl) {
  if (!holder || !window.theme) return;

  uniquifyInjectedUpsellIds(holder);

  const section = holder.querySelector('[data-section-type="product"]');
  // Option → ATC sync must work even when theme.Product throws (no gallery, etc.).
  if (section) wireUpsellOptionSync(section);
  wireUpsellOptionSync(holder);
  if (modalEl) wireUpsellOptionSync(modalEl);

  // Warm full variant list — Liquid JSON is capped around 250.
  const handle = section && section.getAttribute('data-product-handle');
  if (handle) fetchUpsellProductVariants(handle);

  const sectionId = section && section.getAttribute('data-section-id');
  let instance =
    sectionId && theme.sections && typeof theme.sections._findInstance === 'function'
      ? theme.sections._findInstance(sectionId)
      : null;

  // Reuse only if the Product was created for this holder's section (not a twin modal).
  if (instance && instance.container && !holder.contains(instance.container)) {
    instance = null;
  }

  if (!instance && section && theme.Product) {
    try {
      ensureUpsellProductScaffold(section);
      instance = new theme.Product(section);
      if (theme.sections && Array.isArray(theme.sections.instances)) {
        theme.sections.instances.push(instance);
      }
    } catch (err) {}
  }

  if (instance) {
    // Impulse always looks up QuickShopModal-{productId} without -popup/-qs.
    // Point this instance at the modal that actually holds it.
    if (modalEl) {
      instance.modal = modalEl;
      instance.inModal = true;
    }
    try {
      instance.cacheElements();
    } catch (err) {}
    if (instance.cache && instance.cache.form) {
      try {
        if (!instance.variants) instance.formSetup();
        else if (typeof instance.initVariants === 'function' && !instance._starfireUpsellVariantsReady) {
          instance.initVariants();
        }
      } catch (err) {
        try { instance.formSetup(); } catch (e2) {}
      }
      try { instance.productSetup(); } catch (err) {}
      instance.cache.form.dataset.ajaxBound = 'true';
      instance._starfireUpsellVariantsReady = true;
    }
    instance.settings.modalInit = true;
    if (instance.container) {
      instance.container._starfireProduct = instance;
      if (instance.variants) instance.container._starfireVariants = instance.variants;
      wireUpsellOptionSync(instance.container);
      if (
        instance.variantsObject &&
        instance.variants &&
        !instance._starfireUpsellAvailability &&
        theme.VariantAvailability
      ) {
        const currentVariantJson = instance.container.querySelector('[data-current-variant-json]');
        const variantType = instance.container.querySelector('[data-type="dropdown"], [data-type="button"]');
        if (currentVariantJson) {
          try {
            new theme.VariantAvailability({
              container: instance.container,
              namespace: instance.settings.namespace || '',
              type: (variantType && variantType.getAttribute('data-type')) || 'dropdown',
              variantsObject: instance.variantsObject,
              currentVariantObject: JSON.parse(currentVariantJson.innerHTML)
            });
            instance._starfireUpsellAvailability = true;
          } catch (err) {}
        }
      }
      syncUpsellMasterSelect(instance.container);
    }

    if (modalEl && modalEl.id) {
      document.addEventListener('modalOpen.' + modalEl.id, function() {
        if (window.AOS) AOS.refreshHard();
        if (instance.container) {
          wireUpsellOptionSync(instance.container);
          syncUpsellMasterSelect(instance.container);
        }
      });
    }
  }

  // formSetup binds AjaxProduct to instance.cache.form; each holder form still needs
  // its own binding when this modal's Product was skipped or shared previously.
  const productForm =
    instance && instance.cache && instance.cache.form && holder.contains(instance.cache.form)
      ? instance.cache.form
      : null;

  holder.querySelectorAll('.product-single__form').forEach(function(form) {
    form.dataset.ajaxBound = 'true';
    bindUpsellModalAjaxAdd(form);
    // Keep a dormant AjaxProduct only when formSetup already attached one;
    // our capture submit owns the real add and blocks native redirect.
    if (!form._starfireAjaxProduct) {
      if (productForm === form && instance && instance.variants) {
        form._starfireAjaxProduct = true;
      } else if (theme.AjaxProduct) {
        form._starfireAjaxProduct = new theme.AjaxProduct(form);
      }
    }
    forceUpsellVariantOnForm(form);
    // Initial paint — and again after any deferred Product/Variants init.
    syncUpsellMasterSelect(getUpsellProductContainer(form) || section || holder);
  });
}

function patchAjaxProductForUpsell() {
  if (!window.theme || !theme.AjaxProduct || theme.AjaxProduct._starfireUpsellPatched) return;
  theme.AjaxProduct._starfireUpsellPatched = true;
  const proto = theme.AjaxProduct.prototype;
  if (!proto || !proto.addItemFromForm) return;
  const original = proto.addItemFromForm;
  proto.addItemFromForm = function(evt, callback) {
    if (this.form && isUpsellModalForm(this.form)) {
      // Owned by submitStarfireUpsellForm (capture). Never fall through to /cart redirect.
      if (evt) {
        evt.preventDefault();
        evt.stopPropagation();
        evt.stopImmediatePropagation();
      }
      submitStarfireUpsellForm(this.form, evt);
      return;
    }
    return original.call(this, evt, callback);
  };

  if (proto.success && !proto._starfireUpsellSuccessPatched) {
    proto._starfireUpsellSuccessPatched = true;
    const originalSuccess = proto.success;
    proto.success = function(product) {
      if (this.form && isUpsellModalForm(this.form)) {
        const errors = this.form.querySelector('.errors');
        if (errors) errors.remove();
        // Skip theme.settings.cartType === 'page' redirect — open drawer instead.
        notifyUpsellAdded(this.form, product, this.addToCart);
        return;
      }
      return originalSuccess.call(this, product);
    };
  }
}

function ensureUpsellProductScaffold(section) {
  // Upsell view has no [data-product-photos]; Impulse Product throws on null mainSlider.
  if (!section || section.querySelector('[data-product-photos]')) return;
  const photos = document.createElement('div');
  photos.setAttribute('data-product-photos', '');
  photos.hidden = true;
  photos.innerHTML = '<div class="product-main-slide starting-slide"><img alt="" width="1" height="1"></div>';
  section.appendChild(photos);
}

function preloadStarfireUpsellModal(handle, productId, btn) {
  const holder = findStarfireUpsellHolder(handle, btn);
  if (!holder) return;

  const modal = holder.closest('.modal-upsell');
  if (modal && modal.closest('.product-section')) {
    document.body.appendChild(modal);
  }

  // Bind open handlers before fetch so "Add this" works even if inject fails.
  ensureUpsellModalWired(productId, modal);
  if (btn) btn.classList.remove('btn--not-ready', 'quick-product__btn--not-ready');

  // Avoid wiping a working modal when Impulse re-calls preload on click.
  if (holder.dataset.upsellContentLoaded === 'true' && holder.querySelector('[data-section-type="product"]')) {
    return;
  }

  if (holder.dataset.upsellContentLoading === 'true') return;
  holder.dataset.upsellContentLoading = 'true';

  fetch(starfireUpsellModalUrl(handle))
    .then((response) => response.text())
    .then((text) => {
      const html = document.createElement('div');
      html.innerHTML = text;
      const div = html.querySelector('.product-section[data-product-handle="' + handle + '"]');
      if (!div) {
        holder.dataset.upsellContentLoading = 'false';
        return;
      }
      delete holder.dataset.upsellIdsUnique;
      holder.innerHTML = '';
      holder.append(div);

      const modalEl = holder.closest('.modal-upsell');
      ensureUpsellModalWired(productId, modalEl);

      try {
        uniquifyInjectedUpsellIds(holder);
        ensureUpsellProductScaffold(holder.querySelector('[data-section-type="product"]'));
        // Skip sections.register — Product ctor crashes without gallery; initInjected boots it.
        initInjectedUpsellProduct(holder, modalEl);
        if (window.theme && theme.collapsibles) theme.collapsibles.init();
        if (window.theme && theme.videoModal) theme.videoModal();
        holder.querySelectorAll('.product-upsell__image [data-aos]').forEach((el) => {
          el.classList.add('aos-animate');
        });
        holder.querySelectorAll('.product-upsell__image .image-element').forEach((img) => {
          img.style.opacity = '1';
        });
        if (window.AOS) AOS.refreshHard();
        holder.dataset.upsellContentLoaded = 'true';
      } catch (err) {
        console.error('Starfire upsell modal init failed', err);
      }
      holder.dataset.upsellContentLoading = 'false';
      if (btn) btn.classList.remove('btn--not-ready', 'quick-product__btn--not-ready');
    })
    .catch(() => {
      holder.dataset.upsellContentLoading = 'false';
      if (btn) btn.classList.remove('btn--not-ready', 'quick-product__btn--not-ready');
    });
}

function patchPreloadProductModal() {
  if (!window.theme || typeof theme.preloadProductModal !== 'function' || theme.preloadProductModal._starfireUpsell) {
    return;
  }
  const original = theme.preloadProductModal.bind(theme);
  theme.preloadProductModal = function(handle, productId, btn) {
    const holder = findStarfireUpsellHolder(handle, btn) || document.getElementById('QuickShopHolder-' + handle);
    // After the first preload moves .modal-upsell to body, it is no longer inside
    // .product-block--upsells — still force ?view=upsell dropdowns.
    if (isStarfireUpsellHolder(holder)) {
      return preloadStarfireUpsellModal(handle, productId, btn);
    }
    return original(handle, productId, btn);
  };
  theme.preloadProductModal._starfireUpsell = true;
}

function initStarfireUpsellQuickShop() {
  patchPreloadProductModal();
  patchAjaxProductForUpsell();
  bindDocumentUpsellAjaxCapture();
  bindDocumentUpsellOptionSync();
  bindUpsellQuickShopOpenFallback();

  if (window.theme && theme.AjaxProduct) {
    document.querySelectorAll('.product-block--upsells .product-single__form--upsell').forEach((form) => {
      if (form.dataset.ajaxBound === 'true') return;
      form.dataset.ajaxBound = 'true';
      bindUpsellModalAjaxAdd(form);
      new theme.AjaxProduct(form);
    });
  }

  document.querySelectorAll('.product-block--upsells .grid-product').forEach((product) => {
    const productId = product.dataset.productId;
    const handle = product.dataset.productHandle;
    if (!productId || !handle) return;
    const btn =
      product.querySelector('.js-modal-open-quick-modal-' + productId + '-popup') ||
      product.querySelector('.js-modal-open-quick-modal-' + productId) ||
      product.querySelector('.quick-product__btn');
    if (!btn) return;
    ensureUpsellModalWired(productId, btn.closest('.modal-upsell') || document.getElementById('QuickShopModal-' + productId));
    preloadStarfireUpsellModal(handle, productId, btn);
  });
}

document.addEventListener('DOMContentLoaded', initStarfireUpsellQuickShop);
// Capture as early as this file loads — don't wait for DOMContentLoaded.
bindDocumentUpsellAjaxCapture();
bindDocumentUpsellOptionSync();
bindUpsellQuickShopOpenFallback();
if (window.theme && theme.AjaxProduct) patchAjaxProductForUpsell();

document.addEventListener('ajaxProduct:added', (event) => {
  const btn = event.detail && event.detail.addToCartBtn;
  if (btn) {
    const modal = btn.closest('.modal');
    const upsellForm = btn.closest('.product-single__form--upsell');
    const isUpsellModal =
      modal && (modal.closest('.product-block--upsells') || modal.classList.contains('modal-upsell'));
    const popupOpen = Boolean(document.querySelector('upsell-popup[open]'));

    if (isUpsellModal) {
      // Live: close Quick Shop only — return to the upsell popup (or page).
      // Non-bubbling close so the cart drawer window binder does not fire.
      const closeBtn = modal.querySelector('.js-modal-close');
      if (closeBtn) {
        closeBtn.dispatchEvent(new MouseEvent('click', { bubbles: false, cancelable: true }));
      }
    }

    // Popup Quick Shop: stay on upsell popup for Continue (both items).
    // On-page lean "Add this": open drawer.
    if (!popupOpen && (isUpsellModal || upsellForm)) {
      openUpsellCartDrawer();
    }
  }

  // After the original PDP add completes (Continue), close the popup.
  const form = btn && btn.closest && btn.closest('.product-single__form-original');
  if (form) {
    document.querySelectorAll('upsell-popup').forEach((el) => {
      el._bypassNextSubmit = false;
      if (el.hasAttribute('open')) el.removeAttribute('open');
      document.body.classList.remove('upsell-modal--open');
    });
  }
});
